import { render, staticRenderFns } from "./RegisterUser.vue?vue&type=template&id=3d2363f6&scoped=true&"
import script from "./RegisterUser.vue?vue&type=script&lang=js&"
export * from "./RegisterUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2363f6",
  null
  
)

export default component.exports